import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { searchBoxHide } from '../../../actions/searchActions';
import { DebounceInput } from 'react-debounce-input';

const ItemSearch = ({ onHandleSearchItem, children, className, placeholder, queryItem, showSearchBox, hideSearchBox, loading }) => (
  <div className={ 'item-search' }>
    <DebounceInput autoComplete='off'
      className={ `form__field ${className}` }
      debounceTimeout={ 1000 }
      name='query'
      onChange={ onHandleSearchItem }
      placeholder={ placeholder }
      type='text'
      value={ queryItem || '' } />
    {showSearchBox &&
    <div className={ 'item-search__box' }>
      <div className={ 'fa fa-times-circle item-search__close' } onClick={ hideSearchBox } />
      {loading ? <div>loading...</div> : children
      }
    </div>}
  </div>
);

ItemSearch.propTypes = {
  className:              PropTypes.string,
  hideSearchBox:          PropTypes.func.isRequired,
  loading:                PropTypes.bool,
  onHandleSearchItem:     PropTypes.func.isRequired,
  placeholder:            PropTypes.string.isRequired,
  queryItem:              PropTypes.string,
  showSearchBox:          PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    showSearchBox: state.getIn(['search', 'showSearchBox']),
    loading: state.getIn(['item', 'loading'])
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideSearchBox: () => dispatch(searchBoxHide())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemSearch);



// WEBPACK FOOTER //
// ./app/components/shared/search/ItemSearch.jsx